import React, { useMemo } from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from '@barracuda-internal/bds-core'
import styles from 'components/pages/support/supportStyles'

import { useFormatMessage } from 'lib/localization'

import {
  useSupportAccessConfirmDialog,
  UseSupportAccessConfirmDialogLogicProps
} from 'components/pages/support/useSupportAccessConfirmDialogLogic'

const BASE_I18N_KEY = 'ess.dialog.support_page.support_access'

export type SupportAccessConfirmProps = UseSupportAccessConfirmDialogLogicProps

function SupportAccessConfirmDialog({ onCloseDialog }: SupportAccessConfirmProps) {
  const formatDialogText = useFormatMessage(BASE_I18N_KEY)
  const classes = styles()
  const [state, eventHandlers] = useSupportAccessConfirmDialog({ onCloseDialog })

  return useMemo(
    () => (
      <Dialog fullWidth maxWidth="sm" open>
        <DialogTitle data-testid="title">{formatDialogText('enable_support_access')}</DialogTitle>
        <DialogContent>
          <Grid container direction="row" alignItems="center">
            <Typography variant="body1">{formatDialogText('following_permission')}</Typography>
          </Grid>
          <Grid container direction="row" alignItems="center">
            <Grid item xs={12}>
              <ul>
                <li className={classes.bulletPoint}>
                  <Typography>{formatDialogText('make_changes')}</Typography>
                </li>
                <li className={classes.bulletPoint}>
                  <Typography variant="body1">{formatDialogText('email_information_text')}</Typography>
                </li>
                <li className={classes.bulletPoint}>
                  <Typography variant="body1">{formatDialogText('email_content_text')}</Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={eventHandlers.onCancel} color="primary" disabled={state.updateInProgress}>
            {formatDialogText('cancel')}
          </Button>
          <Button variant="contained" onClick={eventHandlers.onConfirm} color="primary">
            {formatDialogText('enable')}
          </Button>
        </DialogActions>
      </Dialog>
    ),
    [formatDialogText, state, eventHandlers, classes.bulletPoint]
  )
}

export default SupportAccessConfirmDialog
